export const AdminTypes = {
  FETCH_DASHBOARD_REQUEST: '@admin/FETCH_DASHBOARD_REQUEST',
  FETCH_DASHBOARD_SUCCESS: '@admin/FETCH_DASHBOARD_SUCCESS',
  FETCH_DASHBOARD_FAILURE: '@admin/FETCH_DASHBOARD_FAILURE',
  FETCH_USERS_REQUEST: '@admin/FETCH_USERS_REQUEST',
  FETCH_USERS_SUCCESS: '@admin/FETCH_USERS_SUCCESS',
  FETCH_USERS_FAILURE: '@admin/FETCH_USERS_FAILURE',
  FETCH_USER_DETAIL_REQUEST: '@admin/FETCH_USER_DETAIL_REQUEST',
  FETCH_USER_DETAIL_SUCCESS: '@admin/FETCH_USER_DETAIL_SUCCESS',
  FETCH_USER_DETAIL_FAILURE: '@admin/FETCH_USER_DETAIL_FAILURE',
  FETCH_PAYMENTS_REQUEST: '@admin/FETCH_PAYMENTS_REQUEST',
  FETCH_PAYMENTS_SUCCESS: '@admin/FETCH_PAYMENTS_SUCCESS',
  FETCH_PAYMENTS_FAILURE: '@admin/FETCH_PAYMENTS_FAILURE',
};

export interface AdminUser {
  _id: string;
  basicInfo: {
    name: string;
    phone: string;
  };
  email: string;
  isAdmin: boolean;
  isVerified: boolean;
  isActive: boolean;
  createdAt: string;
}

export interface AdminPayment {
  _id: string;
  userId: string;
  userName: string;
  userEmail: string;
  amount: number;
  date: string;
  referenceMonth: string;
  status: 'paid' | 'pending' | 'overdue';
  source: 'stripe' | 'kiwify' | 'manual';
  kiwifyOrderId?: string;
  notes?: string;
  createdAt: string;
}

export interface DashboardSummary {
  totalUsers: number;
  activeUsers: number;
  trialUsers: number;
  usersNeedingPayment: AdminUser[];
}

export interface AdminState {
  dashboard: DashboardSummary;
  users: AdminUser[];
  userDetail: {
    user: AdminUser | null;
    payments: AdminPayment[];
  };
  payments: AdminPayment[];
  loading: boolean;
}
